export enum LocalStorageKeys {
  RecentQueries = 'recent-queries',
  Token = 'token',
  RequestPasswordChange = 'change-password',
  RefreshToken = 'refresh_token',
  Lang = 'lang',
  LastUrl = 'lastUrl',
  OverallTabs = 'overallTabs',
  ColumnsWidthState = 'columnsWidthState',
}
